import React, { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Button, Typography } from '@material-ui/core';
import { DownloadIcon, SyncIcon } from 'components/Icons';

import { associadoActionBaixarDocumento } from 'store/modules/associado/actions';
import { IReducer } from 'store/Reducer';

import ErrorHandler from 'helpers/utils/ErrorHandler';

import useStyle from './styles';

export default function AssembleiaDocs() {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { currentEvent } = useSelector((state: IReducer) => state.assembleias);
  const { baixandoDocumento } = useSelector(
    (state: IReducer) => state.associado
  );

  const documentos = useMemo(() => {
    return currentEvent?.documentos || [];
  }, [currentEvent]);

  const baixarDocumento = useCallback(
    (idEvento: number, idDocumento: number, nomeArquivo: string) => {
      dispatch(
        associadoActionBaixarDocumento(
          idEvento,
          idDocumento,
          nomeArquivo,
          undefined,
          ErrorHandler
        )
      );
    },
    [dispatch]
  );

  return (
    <dl className={classes.root}>
      {documentos.map((item) => {
        return (
          <div key={item.oidDocumento} className={classes.item}>
            <div className={classes.header}>
              <Typography component='dt' className={classes.title}>
                {item.nomDocumento}
              </Typography>
              <Typography
                className={[
                  classes.description,
                  classes.descriptionMobile,
                ].join(' ')}
                component='dd'
              >
                {item.desDocumento}
              </Typography>
              <Button
                variant='text'
                endIcon={
                  baixandoDocumento === item.oidDocumento ? (
                    <SyncIcon animated />
                  ) : (
                    <DownloadIcon />
                  )
                }
                className={classes.button}
                onClick={() =>
                  baixarDocumento(
                    currentEvent!.id,
                    item.oidDocumento,
                    item.nomDocumento
                  )
                }
                disabled={baixandoDocumento !== null}
              >
                Baixar
              </Button>
            </div>
            <Typography
              className={[classes.description, classes.descriptionDesktop].join(
                ' '
              )}
              component='dd'
            >
              {item.desDocumento}
            </Typography>
          </div>
        );
      })}
    </dl>
  );
}
